import { render, staticRenderFns } from "./Hujjatlar.vue?vue&type=template&id=051c161a&scoped=true&"
import script from "./Hujjatlar.vue?vue&type=script&lang=js&"
export * from "./Hujjatlar.vue?vue&type=script&lang=js&"
import style0 from "./Hujjatlar.vue?vue&type=style&index=0&id=051c161a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c161a",
  null
  
)

export default component.exports